exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/countries-autocomplete/countries-autocomplete.component.scss
// module id = ../../../../../src/app/shared/components/countries-autocomplete/countries-autocomplete.component.scss
// module chunks = main